module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-top-stone-path-remnants.b0a31f11.png";